import React, { CSSProperties, ReactNode, useState } from 'react';
import { useCreateHealthCheckMutation } from '../../../generated/graphql';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { FormField, FormTextArea } from '../../form';
import styles from './NewHealthCheckDialog.module.css';

type NewHealthCheckDialogProps = {
    onClose: () => void,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewHealthCheckDialog = (props: NewHealthCheckDialogProps) => {
    const { style, visible, onClose } = props;
    const [createHealthCheck, createHealthCheckResult] = useCreateHealthCheckMutation();
    const [name, setName] = useState('');
    const [group, setGroup] = useState('');
    const [display, setDisplay] = useState('');
    const [limit, setLimit] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');

    const handleSubmit = () => {
        if (!name || !group || !display || !limit || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        createHealthCheck({
            variables: {
                healthCheck: {
                    name,
                    group,
                    display,
                    limit: Number.parseInt(limit),
                    description,
                }
            }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Health Check"
            type="OkCancel"
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            isLoading={createHealthCheckResult.loading}
            className={styles.NewHealthCheckDialog}
            style={style}
            data-testid="NewHealthCheckDialog">
            <FormField label="Name" name="name" value={name} onChange={setName} />
            <FormField label="Group" name="group" value={group} onChange={setGroup} />
            <FormField label="Display" name="display" value={display} onChange={setDisplay} />
            <FormField label="Limit" name="limit" type="number" value={limit} onChange={setLimit} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewHealthCheckDialog;